/**
 * Used enums
 */

export enum IconButtonType {
	None = 'none',
	Asset = 'asset',
	Default = 'default',
	Exercise = 'exercise',
	GitHub = 'github',
	Link = 'link',
	Pdf = 'pdf',
	YouTube = 'youtube',
	Slides = 'slides',
	MdDoc = 'mddoc',
}

export enum ReferenceType {
	Article = 'article',
	Podcast = 'podcast',
	Link = 'link',
	Video = 'video',
}

/**
 * EduSidebar
 */

export enum EduSideBarType {
	None = 'none',
	YouTube = 'youtube',
	Exercise = 'exercise',
	MdDoc = 'mddoc',
}

/**
 * EduModal
 */

export enum EduModalType {
	None = 'none',
	Slides = 'slides',
}

/**
 * Slides
 */

export enum SlidesType {
	Light = 'light',
	Dark = 'dark',
	Seamless = 'hidden',
	Transparant = 'transparant',
}
